var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.destination}},[_c('v-btn',{attrs:{"color":"secondary","x-small":""}},[_vm._v(" View "),_c('v-icon',{attrs:{"x-small":""}},[_vm._v(" mdi-arrow-right ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }